import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared';

import { COMPONENTS } from './components';
import { SERVICES } from './services';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [...COMPONENTS],
  providers: [...SERVICES],
})
export class AccountCreateModule {}
